<template>
  <div class="pa-2">
    <h3 class="mb-4">
      <v-icon color="white" size="small" class="mr-2">{{ truckIcon }}</v-icon>
      {{
        assetVisit?.company?.name ||
        assetVisit?.companyHint ||
        t('yard.pages.yardView.tooltips.unknownCompany')
      }}
      <br />
      <v-chip size="x-small" class="text-uppercase" color="secondary" v-if="assetVisit">
        {{ t(`core.yard.altAssetVisitTypes.${camelCase(assetVisit?.visitType)}`) }}
      </v-chip>
      <span v-else-if="assetContainer">
        <v-chip size="x-small" class="text-uppercase mr-2" color="secondary">
          {{ t(`core.yard.assetContainerTypes.${camelCase(assetContainer?.type)}`) }}
        </v-chip>
        <v-chip size="x-small" class="text-uppercase" :color="assetContainerStatusColor">
          {{ t(`core.yard.assetContainerEvent.types.${camelCase(assetContainerStatus)}`) }}
        </v-chip>
      </span>
    </h3>

    <v-row>
      <v-col>
        <strong>{{ t('yard.pages.yardView.headers.appointmentStatus') }}</strong>
        <p class="text-capitalize" v-if="!appointment?.id">
          {{ t('yard.pages.yardView.tooltips.noAppointmentScheduled') }}!
        </p>

        <p v-else>
          <v-chip :color="appointment.status.toLowerCase()" size="small" pill>
            {{ t(`global.appointmentStatuses.${appointment.status}`).toUpperCase() }}
          </v-chip>
        </p>
      </v-col>

      <v-col>
        <strong>{{ t('assetVisit.common.terms.docked') }}</strong>
        <p class="text-capitalize">{{ dockedTime }}</p>
      </v-col>
    </v-row>
    <v-row v-if="appointment?.id">
      <v-col>
        <strong>
          {{ getTranslatedRefNumberDisplayName($refNumSettings(selectedWarehouse).displayName) }}
        </strong>
        <p>{{ appointment.refNumber || '-' }}</p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { computed, defineComponent } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { getTranslatedRefNumberDisplayName, LuxonDateTimeFormats } from '@nova/core';
import { useI18n } from 'vue-i18n';
import { camelCase } from 'lodash';

export default defineComponent({
  name: 'YardViewSpotTooltip',
  methods: { getTranslatedRefNumberDisplayName, camelCase },
  props: {
    spot: {
      type: Object,
      required: true
    },
    appointment: {
      type: Object,
      required: false
    }
  },
  setup(props) {
    const { t } = useI18n();
    const yardStore = useYard();

    const spotAssignment = computed(() => props.spot.spotAssignments[0]);
    const assetVisit = computed(() => spotAssignment.value?.assetVisit);
    const assetContainer = computed(() => spotAssignment.value?.assetContainer);

    const dockedTime = computed(() => {
      return yardStore.formatDateTime(
        spotAssignment.value?.createDateTime,
        LuxonDateTimeFormats.Extended12HrTimeAMPM,
        LuxonDateTimeFormats.Extended24HrTime
      );
    });

    const truckIcon = computed(() => {
      if (!props.assetVisit) {
        return 'mdi-truck-trailer';
      }

      return yardStore.getTruckIcon(props.assetVisit?.visitType);
    });

    const assetContainerStatus = computed(() =>
      yardStore.getAssignedAssetContainerStatus(assetContainer.value?.assetContainerEvents)
    );

    const assetContainerStatusColor = computed(() => {
      return yardStore.getAssetContainerStatusColor(assetContainerStatus.value);
    });

    return {
      t,
      truckIcon,
      assetContainerStatus,
      assetContainerStatusColor,
      selectedWarehouse: yardStore.selectedWarehouseRef,
      spotAssignment,
      assetVisit,
      assetContainer,
      dockedTime
    };
  }
});
</script>

<style scoped lang="scss"></style>
